import React from "react";
import user from "../../assets/user.avif";
import { userProfile } from "../../data/user-dashboard";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CiLogout } from "react-icons/ci";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/store/userSlice";
import { toast } from "react-toastify";
const Sidebar = ({ close, isMobile }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
    toast.success("You have logged out successfully!", { autoClose: 3000 });
    navigate("/");
  };
  return (
    // <div className="hidden md:flex flex-[0.3] shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-[2rem] px-[2rem]">
    //   <hr />

    <div className="w-[300px]">
      <div className="my-[1.5rem]  flex items-start justify-center gap-[1rem] flex-col">
        <>
          {userProfile.map((link, index) => {
            const isActive =
              location.pathname === link.link ||
              (!userProfile.some((l) => l.link === location.pathname) &&
                link.link === "/user/profile");
            return (
              <Link
                onClick={() => {
                  if (isMobile) close();
                }}
                to={link.link}
                className={`flex items-center gap-[0.5rem] w-full p-[0.6rem] 
           rounded-lg  text-[18px] hover:text-black ${isActive ? "text-black" : "text-gray-500"}
          transition-all duration-300 ease-in-out 
           `}
              >
                {link.icon}
                {link.title}
              </Link>
            );
          })}
          <Link
            onClick={() => {
              handleLogout();
              if (isMobile) close();
            }}
            className={`flex items-center gap-[0.5rem] w-full p-[0.6rem] 
           rounded-lg  text-[18px] text-gray-500 hover:text-black }
          transition-all duration-300 ease-in-out 
           `}
          >
            <CiLogout />
            Logout
          </Link>
        </>
      </div>
    </div>
    //   <hr />
    // </div>
  );
};

export default Sidebar;
